<template>
	<div
		class="product-cross-sell"
		v-if="products.length"
	>
		<h2
			class="product-cross-sell__title"
			v-html="$t('shoplist.product.crossSellTitle')"
		/>
		<div class="product-cross-sell__products">
			<!-- loop -->
			<ShoplistProduct
				v-for="(product, index) in productsEnhanced"
				:key="product.code"
				:product="product"
				:locked="lockedProducts[product.code]"
				@addToCart="onAddToCart"
				@config="onConfig"
				@click="onClickProduct"
			/>
			<!-- loop end -->
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import GenericMixin from '@/mixins/GenericVueMixin'
import ProductListMixin from '@/mixins/ProductListVueMixin'
import ShoplistProduct from '@/components/ShoplistProduct'
import Loader from '@/components/Loader';

export default {
	mixins: [
		GenericMixin,
		ProductListMixin,
	],
	components: {
		ShoplistProduct,
		Loader,
	},
	props: {
		products: Array,
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
			"accountGroupCodes",
		]),
		productsEnhanced() {
			return this.enhanceProducts(this.products, 0);
		}
	},
	methods: {
		onClickProduct(code) {
			// console.log(this.getProduct(code));
		},
	}
}
</script>

<style>

</style>
